module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11,4.71428571 C14.4571429,4.71428571 17.2857143,7.54285714 17.2857143,11 C17.2857143,14.4571429 14.4571429,17.2857143 11,17.2857143 C8.95714286,17.2857143 7.07142857,16.1857143 5.81428571,14.6142857 L11,11 L11,4.71428571\" id=\"Shape\"></path></svg>\n"


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/app/views/shared/icons/_icon_status_running_borderless.svg
// module id = ../../views/shared/icons/_icon_status_running_borderless.svg
// module chunks = commit_pipelines job_details pipelines pipelines_details vue_merge_request_widget